import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getOverview () {
    return Api()
      .get('/v1/products')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Product.Messages.GetProductsErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getByUid (productUid) {
    return Api()
      .get('/v1/products/' + productUid)
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Product.Messages.GetProductErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getByVariant (variantUids) {
    return Api()
      .get('/v1/products/variant', { params: { uids: variantUids } })
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Product.Messages.GetProductErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getPrices (productUid, customerUid) {
    var url = '/v1/products/' + productUid + '/Prices'
    if (customerUid) {
      url = url + '?customerUid=' + customerUid
    }
    return Api()
      .get(url)
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Product.Messages.GetPricesErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getAllPrices (productUid, customerUid) {
    var url = '/v1/products/' + productUid + '/Prices/All'
    if (customerUid) {
      url = url + '?customerUid=' + customerUid
    }
    return Api()
      .get(url)
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Product.Messages.GetPricesErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getVariantPrices (productUid, productVariantUid, customerUid) {
    var url =
      '/v1/products/' + productUid + '/Prices/Variant/' + productVariantUid
    if (customerUid) {
      url = url + '?customerUid=' + customerUid
    }
    return Api()
      .get(url)
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t(
            'Services.Product.Messages.GetVariantPricesErrorMessage'
          ),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  activePriceItemIndex (priceList, quantity) {
    if (
      isNaN(quantity) ||
      priceList.length === 0 ||
      quantity < priceList[0].tierQuantity
    ) {
      return 0
    }
    // priceItems come sorted by tierQuantity
    for (var i = 0; i < priceList.length; i++) {
      // if the active count is smaller than the price item tier, the current is the previous or lowest tier
      if (quantity < priceList[i].tierQuantity) {
        return i - 1
      }
    }
    // we are in the highest tier
    return priceList.length - 1
  },
}
